/* eslint-disable no-unused-vars */
import { useCallback, useContext } from 'react';

import ReCaptchaContext from '@/contexts/ReCaptchaContext';
import { logError } from '@/helpers/logger/logUtils';

type ReCaptchaCallback = {
  action: string;
  callback: (rcToken: string, ...props: any[]) => void;
};

const useReCaptchaCallback = <T extends unknown[] = unknown[]>({
  action,
  callback,
}: ReCaptchaCallback): ((...props: T) => void) => {
  const { scoredBasedKey } = useContext(ReCaptchaContext);

  return useCallback(
    (...props: T) => {
      window.grecaptcha?.enterprise.ready(async () => {
        try {
          const rcToken = await window.grecaptcha?.enterprise.execute(scoredBasedKey, { action });

          if (rcToken) {
            callback(rcToken, ...props);
          }
        } catch (error) {
          logError(`Recaptcha loading error: ${(error as Error).message}`);
        }
      });
    },
    [action, callback, scoredBasedKey],
  );
};

export default useReCaptchaCallback;
